<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <keep-alive>
        <!-- 使用fullPath作为key，避免在keep-alive中，路由相同传，路径传参不同，却都共用一个vnode缓存 -->
        <router-view :key="$route.fullPath" ref="page" v-if="keepAlivePath.includes($route.path)"/>
      </keep-alive>
      <router-view :key="$route.fullPath" ref="page" v-if="!keepAlivePath.includes($route.path)"/>
      <!--      <router-view v-if="isRouterAlive"/>-->
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { deviceEnquire, DEVICE_TYPE } from '@/utils/device'
import { version } from 'ant-design-vue'
import { keepAlivePath } from '@/layouts/NeedKeepAlivePath'

export default {
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      keepAlivePath,
      locale: zhCN,
      version,
      isRouterAlive: true
    }
  },
  mounted () {
    const { $store } = this
    deviceEnquire(deviceType => {
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          $store.commit('TOGGLE_DEVICE', 'desktop')
          $store.dispatch('setSidebar', true)
          break
        case DEVICE_TYPE.TABLET:
          $store.commit('TOGGLE_DEVICE', 'tablet')
          $store.dispatch('setSidebar', false)
          break
        case DEVICE_TYPE.MOBILE:
        default:
          $store.commit('TOGGLE_DEVICE', 'mobile')
          $store.dispatch('setSidebar', true)
          break
      }
    })
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style>
#app {
  height: 100%;
}
</style>
